import { Button } from '@playcanvas/pcui/react';
import React from 'react';
import { version as appVersion } from '../../package.json';

interface AboutDialogProps {
    onClose: () => void;
}

class AboutDialog extends React.Component<AboutDialogProps> {
    componentDidMount() {
        document.addEventListener('keydown', this.handleEscape);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleEscape);
    }

    handleEscape = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            this.props.onClose();
        }
    };

    render() {
        return (
            <div className="about-dialog-overlay" onClick={this.props.onClose}>
                <div className="about-dialog" onClick={(e) => e.stopPropagation()}>
                    <div className="about-dialog-header">
                        <div className="about-dialog-title">About Model Viewer</div>
                        <Button 
                            class='about-dialog-close' 
                            icon='E132' 
                            onClick={this.props.onClose}
                        />
                    </div>
                    <div className="about-dialog-body">
                        <div className="about-logo">
                            <img src="static/logo.png" alt="Logo" />
                        </div>
                        <div className="about-version">
                            Version {appVersion}
                        </div>
                        <div className="about-credits-section">
                            <div className="about-credits-title">✨ Entirely Vibe-Coded By:</div>
                            <div className="about-ai-credits">
                                <div className="about-ai-name">Claude</div>
                                <div className="about-ai-name">Grok</div>
                                <div className="about-ai-name">GPT-5</div>
                            </div>
                            <div className="about-human-credit">
                                With expert prompting by <strong>Laura</strong>
                            </div>
                        </div>
                        <div className="about-witty-message">
                            <em>"No humans were harmed in the making of this UI.<br/>
                            (Though several AIs lost their minds debugging SCSS.)"</em>
                        </div>
                        <div className="about-footer">
                            Built with PlayCanvas Engine
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutDialog;

